import R from 'ramda';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import music from '../../assets/music.svg';
import photo from '../../assets/photo.svg';
import text from '../../assets/text.svg';
import video from '../../assets/video.svg';

class Sidebar extends Component {
  renderType() {
    const { fields, workTypes } = this.props;

    if (fields.type) {
      let src = null;
      let title = '';
      const workType = R.find(R.propEq('id', parseInt(fields.type, 10)))(
        workTypes
      );

      if (workType) {
        switch (workType.name) {
          case 'Music':
            src = music;
            title = workType.name;
            break;
          case 'Video':
            src = video;
            title = workType.name;
            break;
          case 'Image':
            src = photo;
            title = workType.name;
            break;
          case 'Document':
            src = text;
            title = 'Literature';
            break;
          default:
            break;
        }

        return (
          <div className="type">
            <img src={src} alt={title} />
            <h2>{title}</h2>
          </div>
        );
      }
    }
  }

  renderName() {
    if (this.props.fields.name) {
      return <div className="name text">{this.props.fields.name}</div>;
    }
  }

  renderSubtype() {
    const { fields, subWorkTypes } = this.props;

    if (fields.subtype) {
      const subWorkType = R.find(R.propEq('id', parseInt(fields.subtype, 10)))(
        subWorkTypes
      );

      if (subWorkType) {
        return <div className="subtype text">{subWorkType.name}</div>;
      }
    }
  }

  renderTeam() {
    if (this.props.team) {
      return <div className="team text">{this.props.team.name}</div>;
    }
  }

  renderAgreement() {
    if (this.props.fields.agreement) {
      return <div className="agreement text">{this.props.agreement.name}</div>;
    }
  }

  render() {
    return (
      <div className="sidebar">
        {this.renderType()}
        {this.renderName()}
        {this.renderSubtype()}
        {this.renderTeam()}
        {this.renderAgreement()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  workTypes: state.global.workTypes,
  subWorkTypes: state.global.subWorkTypes,
  team: state.teams.selectedTeam,
});

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// src/components/Deals/Sidebar.jsx